export default [
    {
        key: "delta",
        label: "δ",
    },
    {
        key: "theta",
        label: "θ",
    },
    {
        key: "lowAlpha",
        label: "Low α",
    },
    {
        key: "highAlpha",
        label: "High α",
    },
    {
        key: "lowBeta",
        label: "Low β",
    },
    {
        key: "highBeta",
        label: "High β",
    },
    {
        key: "lowGamma",
        label: "Low γ",
    },
    {
        key: "middleGamma",
        label: "Middle γ",
    },
]